import { IUserRoles } from "./../../models/IUserRoles";

export class UserRolesState {
  userRoles: IUserRoles[] = [];
}
